import React from "react";
import "./styles.scss";
import "./mobile.scss";

const Index = ({ data, onChange, onClick, length }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`news-header-wrapper ${data?.url === "" ? "default" : ""}`}
        onClick={onClick}
      >
        <div className={"nhw__bullet"}></div>
        {/* <div className={"nhw__content"}>
          {data.newsContent}
          {/* {data.newsContent &&
            data.newsContent.length > 20?.substring(0, 20).trimEnd() + "..."}
        </div> */}
        <div
          className={"nhw__content"}
          dangerouslySetInnerHTML={{
            __html: data.newsContent,
          }}
        ></div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};

export default Index;
